export default [
  {
    key: 'name',
    label: 'field.departmentName',
    type: 'text',
    // rules: 'required|email|max:100|company_email',
    rules: 'required|max:100',
  },
  {
    key: 'workScheduleId',
    label: 'breadcrumb.workingSchedule',
    type: 'async-single-selection',
    repository: 'workingScheduleTemplate',
    selectionKey: 'id',
    selectionLabel: 'title',
    rules: 'required',
  },
]
